var render = function render(){var _vm=this,_c=_vm._self._c;return _c('List',{staticClass:"link-list"},_vm._l((_vm.linkComponents),function(link){return _c(link.component,{key:link.type || link.id,tag:"component",attrs:{"disabled":link.disabled},on:{"click":function($event){return _vm.$emit('click', $event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }